import { FC } from "react";

import { buttonClasses, styled } from "@mui/material";

import Button, { ButtonProps } from "@rui/Button";
import Stack from "@rui/Stack";

export const NudgeOuterContainer = styled(Stack)({
  position: "absolute",
  top: 70,
  bottom: 24,
  left: 0,
  right: 0,
  pointerEvents: "none",
});

export const NudgeInnerContainer = styled(Stack)({
  position: "relative",
  height: "100%",
  width: "100%",
  pointerEvents: "none",
});

export interface NudgeProps extends ButtonProps {
  label: string;
  placement?: "top" | "bottom";
}

const OFFSET = 8;

export const NudgeComponent = styled<FC<NudgeProps>>(
  ({ label, placement: _, ...props }) => <Button {...props}>{label}</Button>
)(({ placement, theme }) => ({
  "@keyframes nudge-bounce": {
    "0%": { transform: "translate3d(-50%, 0, 0)" },
    "25%": { transform: `translate3d(-50%, ${OFFSET}px, 0)` },
    "50%": { transform: "translate3d(-50%, 0px, 0)" },
    "100%": { transform: "translate3d(-50%, 0px, 0)" },
  },
  animation: "nudge-bounce 2.5s infinite ease",
  backgroundColor: theme.palette.shades.neutral[700],
  color: "#FFF",
  borderRadius: "8px",
  height: "34px",
  fontFamily: "Inter",
  fontSize: "0.875rem",
  fontWeight: 400,
  whiteSpace: "nowrap",
  position: "absolute",
  left: "50%",
  ...(placement && {
    top: placement === "top" ? OFFSET : undefined,
    bottom: placement === "bottom" ? OFFSET * 2 : undefined,
  }),
  zIndex: 10,
  pointerEvents: "all",
  "&:hover": {
    backgroundColor: theme.palette.shades.neutral[800],
  },
  [`& .${buttonClasses.startIcon}`]: {
    marginRight: theme.spacing(0.5),
  },
  "& svg": {
    padding: "2px",
    paddingRight: 0,
  },
}));
